var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoyaltyTrackingSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.82113281 0.77601563 1.64226562 1.55203125 2.48828125 2.3515625 C3.79732422 3.54652344 3.79732422 3.54652344 5.1328125 4.765625 C32.03736864 30.2460487 48.18001647 68.95578717 49.76953125 105.7265625 C50.38177629 129.66385011 46.28755993 153.4472697 36.52734375 175.34765625 C35.38415036 178.14615335 35.38415036 178.14615335 35.45703125 180.41015625 C37.12022284 183.54124042 39.73251514 185.67233176 42.36328125 187.9765625 C42.90597656 188.46640625 43.44867187 188.95625 44.0078125 189.4609375 C46.41792433 191.61766349 48.79336648 193.55495265 51.48828125 195.3515625 C51.48828125 196.0115625 51.48828125 196.6715625 51.48828125 197.3515625 C52.0702124 197.61130859 52.65214355 197.87105469 53.25170898 198.13867188 C55.64703404 199.43765396 57.31084442 200.87324146 59.2734375 202.7578125 C59.96888672 203.41910156 60.66433594 204.08039063 61.38085938 204.76171875 C62.09693359 205.45136719 62.81300781 206.14101563 63.55078125 206.8515625 C64.97731972 208.21807652 66.40563426 209.58273949 67.8359375 210.9453125 C68.46508057 211.55052734 69.09422363 212.15574219 69.74243164 212.77929688 C71.60900523 214.53649311 71.60900523 214.53649311 74.48828125 216.3515625 C74.48828125 217.0115625 74.48828125 217.6715625 74.48828125 218.3515625 C75.06642578 218.60752197 75.64457031 218.86348145 76.24023438 219.12719727 C78.71091142 220.4728147 80.43169679 221.99229142 82.45703125 223.94140625 C83.19308594 224.64330078 83.92914062 225.34519531 84.6875 226.06835938 C85.82638672 227.16760742 85.82638672 227.16760742 86.98828125 228.2890625 C88.49693087 229.73751981 90.00728986 231.18419928 91.51953125 232.62890625 C92.51823242 233.59171509 92.51823242 233.59171509 93.53710938 234.57397461 C95.47095743 236.40587745 95.47095743 236.40587745 97.73632812 237.95922852 C98.31447266 238.41869873 98.89261719 238.87816895 99.48828125 239.3515625 C99.48828125 240.0115625 99.48828125 240.6715625 99.48828125 241.3515625 C100.07738281 241.61324219 100.66648437 241.87492187 101.2734375 242.14453125 C103.60613559 243.41579 105.09182493 244.75386781 106.92578125 246.6640625 C107.5290625 247.28667969 108.13234375 247.90929687 108.75390625 248.55078125 C109.61242187 249.44216797 109.61242187 249.44216797 110.48828125 250.3515625 C111.81859375 251.6509375 111.81859375 251.6509375 113.17578125 252.9765625 C119.7751165 259.75425816 123.41637171 267.77207767 123.98828125 277.3515625 C123.24283532 289.07991185 118.08207419 298.18311229 109.73828125 306.0390625 C101.84334791 312.63826251 92.52528142 316.81293645 82.17578125 316.2265625 C75.58723858 315.47200873 69.40923357 313.31203866 63.48828125 310.3515625 C63.48828125 309.6915625 63.48828125 309.0315625 63.48828125 308.3515625 C62.90046875 308.08214844 62.31265625 307.81273437 61.70703125 307.53515625 C59.48270636 306.34858857 57.86081504 305.09359391 55.98828125 303.4140625 C55.29734375 302.79660156 54.60640625 302.17914062 53.89453125 301.54296875 C50.55851668 298.50481262 47.23183507 295.45657185 43.91210938 292.40063477 C41.13492984 289.84715302 38.33921313 287.32237013 35.48828125 284.8515625 C30.5797601 280.592102 25.81556433 276.17519939 21.03515625 271.7734375 C19.56413015 270.4212822 18.0888192 269.07379281 16.61328125 267.7265625 C12.16648682 263.66644585 7.73611725 259.59225165 3.3515625 255.46484375 C2.6390332 254.79420898 1.92650391 254.12357422 1.19238281 253.43261719 C-0.2044667 252.11602442 -1.59972677 250.79774267 -2.99316406 249.47753906 C-6.39038131 246.27406007 -9.80494572 243.20127819 -13.51171875 240.3515625 C-14.1665625 240.77566406 -14.82140625 241.19976563 -15.49609375 241.63671875 C-18.48968313 243.56056503 -21.49831668 245.45890849 -24.51171875 247.3515625 C-25.4140625 247.92648437 -26.31640625 248.50140625 -27.24609375 249.09375 C-59.33807389 268.76595252 -102.48493333 275.40695014 -139.29736328 266.89941406 C-152.36515548 263.66632413 -164.54485323 259.53209657 -176.51171875 253.3515625 C-177.48367188 252.85785156 -178.455625 252.36414063 -179.45703125 251.85546875 C-191.61642097 245.46399467 -202.35270815 237.53015387 -212.51171875 228.3515625 C-213.01703125 227.8982959 -213.52234375 227.4450293 -214.04296875 226.97802734 C-241.90129112 201.63166958 -258.23220027 163.69580514 -260.51171875 126.3515625 C-261.82280358 89.42857898 -255.20437119 54.34653487 -232.51171875 24.3515625 C-232.12193848 23.83319824 -231.7321582 23.31483398 -231.33056641 22.78076172 C-221.42596576 9.63437804 -221.42596576 9.63437804 -216.51171875 4.3515625 C-215.85171875 4.3515625 -215.19171875 4.3515625 -214.51171875 4.3515625 C-214.51171875 3.6915625 -214.51171875 3.0315625 -214.51171875 2.3515625 C-211.54384044 -0.408148 -208.32198188 -2.85948067 -205.13671875 -5.36328125 C-203.56149148 -6.60907397 -202.00498464 -7.87842453 -200.44921875 -9.1484375 C-142.18268468 -56.15298659 -54.20139394 -50.31134174 0 0 Z M-176.51171875 28.3515625 C-177.22328125 28.93292969 -177.93484375 29.51429688 -178.66796875 30.11328125 C-180.32739484 31.47308874 -181.92736678 32.90498026 -183.51171875 34.3515625 C-183.51171875 35.0115625 -183.51171875 35.6715625 -183.51171875 36.3515625 C-184.06601562 36.55910156 -184.6203125 36.76664063 -185.19140625 36.98046875 C-200.31556823 45.91747355 -209.16373312 70.51447669 -213.39453125 86.48828125 C-220.60720081 116.30420179 -215.71727738 147.30043945 -200.53125 173.80859375 C-196.16635403 180.5955278 -191.08114294 186.53204327 -185.51171875 192.3515625 C-184.83753906 193.10050781 -184.16335938 193.84945312 -183.46875 194.62109375 C-169.12778287 209.98449381 -147.16909114 220.89748887 -126.51171875 224.3515625 C-125.0956218 224.39173546 -123.67772547 224.39479935 -122.26171875 224.3515625 C-121.02421875 224.3515625 -119.78671875 224.3515625 -118.51171875 224.3515625 C-118.18171875 224.6815625 -117.85171875 225.0115625 -117.51171875 225.3515625 C-87.83148426 227.68803134 -58.73566672 220.6239055 -35.67578125 201.20703125 C-34.96164062 200.59472656 -34.2475 199.98242188 -33.51171875 199.3515625 C-32.90070313 198.87332031 -32.2896875 198.39507813 -31.66015625 197.90234375 C-26.09340765 193.46673813 -21.84192757 187.96308088 -17.51171875 182.3515625 C-16.90199219 181.56910156 -16.29226563 180.78664063 -15.6640625 179.98046875 C2.254921 155.77555482 8.73958131 124.47691088 4.42578125 94.9140625 C1.18614525 75.14679201 -7.54177005 57.51599276 -20.51171875 42.3515625 C-21.17107422 41.51044922 -21.17107422 41.51044922 -21.84375 40.65234375 C-37.87095247 20.22972121 -65.70594725 7.62584689 -90.8515625 4.015625 C-121.37837559 0.35438648 -153.2282529 7.71789407 -176.51171875 28.3515625 Z ",
    fill: "#FEFEFE",
    transform: "translate(613.51171875,378.6484375)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.78117188 0.09651855 1.56234375 0.19303711 2.3671875 0.29248047 C20.11624444 2.56713865 37.53428168 6.90827723 54.4375 12.75 C55.29013428 13.04358398 56.14276855 13.33716797 57.02124023 13.63964844 C62.87131887 15.74263775 62.87131887 15.74263775 64 18 C65.03447266 18.20689453 65.03447266 18.20689453 66.08984375 18.41796875 C69.84841001 19.169682 73.11903148 20.6859713 76.5625 22.3125 C77.29049805 22.6535376 78.01849609 22.9945752 78.76855469 23.34594727 C85.89606446 26.78108204 92.61975294 30.83665322 99.31079102 35.05004883 C100.11057373 35.54786865 100.91035645 36.04568848 101.734375 36.55859375 C102.43788086 37.00517334 103.14138672 37.45175293 103.86621094 37.91186523 C106.30653688 39.15631978 108.26697557 39.77096175 111 40 C113.86216533 37.87097038 113.86216533 37.87097038 115.78125 36.015625 C118.56229431 33.48918334 121.51587507 31.21519467 124.5 28.9375 C125.03367187 28.52653076 125.56734375 28.11556152 126.1171875 27.69213867 C130.01597709 24.70445342 133.99181873 21.8391284 138 19 C136.86041815 34.71789113 135.56163305 50.42135727 134.20715332 66.12200928 C134.02771316 68.20352322 133.8490806 70.28510694 133.67126465 72.36676025 C133.41747013 75.33327181 133.16038433 78.29948011 132.90234375 81.265625 C132.82634445 82.15847198 132.75034515 83.05131897 132.67204285 83.97122192 C132.28655636 88.35641742 131.80377972 92.6665789 131 97 C128.36 97 125.72 97 123 97 C123 96.34 123 95.68 123 95 C122.14664062 94.9575415 121.29328125 94.91508301 120.4140625 94.87133789 C107.23553457 94.13683875 94.12826169 92.78003573 81 91.4375 C78.66409076 91.2008927 76.32815343 90.96456253 73.9921875 90.72851562 C68.32779756 90.15553488 62.66376258 89.57914752 57 89 C57 88.34 57 87.68 57 87 C58.64453125 85.52734375 58.64453125 85.52734375 60.8125 83.9375 C61.52019531 83.41027344 62.22789062 82.88304687 62.95703125 82.33984375 C65 81 65 81 68 80 C68 79.34 68 78.68 68 78 C69.4609375 76.4921875 69.4609375 76.4921875 71.375 74.875 C72.00148438 74.33617187 72.62796875 73.79734375 73.2734375 73.2421875 C75 72 75 72 77 72 C77 71.34 77 70.68 77 70 C77.66 70 78.32 70 79 70 C75.30034449 65.61370482 70.57250775 63.34715816 65.5625 60.75 C64.63236084 60.26764893 63.70222168 59.78529785 62.74389648 59.28833008 C40.58372273 48.04128171 16.65107496 40.98404621 -8 38 C-9.07636719 37.86851562 -10.15273438 37.73703125 -11.26171875 37.6015625 C-28.41012432 35.94276248 -45.97215845 36.46211065 -63 39 C-63.76779785 39.1129541 -64.5355957 39.2259082 -65.32666016 39.34228516 C-86.41344864 42.6164134 -107.42233045 49.46557304 -126 60 C-126.68707031 60.37737305 -127.37414062 60.75474609 -128.08203125 61.14355469 C-144.04000348 69.92043942 -169.60659108 85.21318217 -178 102 C-178.66 102 -179.32 102 -180 102 C-180.23589844 102.53882813 -180.47179687 103.07765625 -180.71484375 103.6328125 C-182.34851988 106.64195455 -184.43380901 109.20989825 -186.5625 111.875 C-193.67000565 120.94987778 -200.1713508 130.50293652 -205 141 C-212.97110815 138.54933568 -220.47008922 135.24006872 -228.0625 131.8125 C-229.32208993 131.24765492 -230.5818544 130.68319889 -231.84179688 130.11914062 C-234.89626383 128.74989682 -237.94891809 127.37676603 -241 126 C-225.92868712 94.02248125 -202.59626956 64.89221419 -174 44 C-173.46020508 43.60474121 -172.92041016 43.20948242 -172.36425781 42.80224609 C-139.5611661 19.00255615 -99.66611147 2.16395375 -59 -1 C-57.40285156 -1.16242188 -57.40285156 -1.16242188 -55.7734375 -1.328125 C-37.19776186 -3.01279248 -18.47967954 -2.33554494 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(539,258)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.70863641 1.35431821 3.02049821 2.79612565 4.28515625 5.53125 C4.72867432 6.47822754 5.17219238 7.42520508 5.62915039 8.40087891 C6.33865845 9.93494385 6.33865845 9.93494385 7.0625 11.5 C10.41062747 18.63074896 13.80722823 25.69930779 17.5625 32.625 C22.75862088 42.23048848 27.37590575 52.10953574 32 62 C28.68176068 62.92986962 26.9289611 62.94625019 23.625 61.875 C22.76390625 61.59785156 21.9028125 61.32070313 21.015625 61.03515625 C15.32247443 59.0809012 9.65509023 57.06158188 4 55 C4.33 55.33 4.66 55.66 5 56 C4.01 56.495 4.01 56.495 3 57 C2.49230206 94.73888024 8.57607583 130.43903004 26.0625 164.1875 C26.54460937 165.11892822 27.02671875 166.05035645 27.5234375 167.01000977 C30.90396122 173.35589517 34.76630927 179.19428975 39 185 C39.74765625 186.04929687 40.4953125 187.09859375 41.265625 188.1796875 C46.32415536 195.05052598 51.73219345 201.39279308 57.61914062 207.55175781 C58.94025857 208.93734332 60.24401771 210.33941785 61.546875 211.7421875 C73.50544014 224.24432379 87.91763685 234.57441756 103 243 C103.66 243 104.32 243 105 243 C105 243.66 105 244.32 105 245 C105.69867188 245.26683594 106.39734375 245.53367187 107.1171875 245.80859375 C110.20498127 247.08471448 113.13659024 248.56829512 116.125 250.0625 C142.02074629 262.43295225 168.56870989 267.27295647 196.95239258 268.76635742 C200.33067849 269.02535122 203.65129034 269.48955314 207 270 C207.45234965 275.39293305 207.89777171 280.78637544 208.33666992 286.18041992 C208.48708965 288.01684155 208.63943015 289.85310688 208.79370117 291.68920898 C209.01461111 294.32237021 209.22869665 296.95600905 209.44140625 299.58984375 C209.51218887 300.41588608 209.5829715 301.24192841 209.65589905 302.09300232 C209.81133622 304.05920511 209.91145251 306.02965144 210 308 C208.15209726 309.84790274 205.22620369 309.17410063 202.75 309.1875 C145.16943073 308.86822491 89.66553486 287.18565785 46 250 C45.26652344 249.40058594 44.53304687 248.80117188 43.77734375 248.18359375 C42.14458335 246.83648527 40.56468987 245.42560632 39 244 C39 243.34 39 242.68 39 242 C38.1646875 241.6596875 38.1646875 241.6596875 37.3125 241.3125 C34.33840412 239.62449964 32.27991135 237.53323483 30 235 C30 234.34 30 233.68 30 233 C29.41992188 232.76152344 28.83984375 232.52304687 28.2421875 232.27734375 C23.40708445 229.52285125 20.34195813 224.35902664 17 220 C16.45956055 219.29536621 15.91912109 218.59073242 15.36230469 217.86474609 C-16.25489921 176.36606017 -34.40021189 126.97348356 -34.125 74.4375 C-34.12306641 73.51437012 -34.12113281 72.59124023 -34.11914062 71.64013672 C-34.0605839 62.07749788 -33.57964079 52.54337164 -33 43 C-36.56164658 41.37312482 -40.12446482 39.74883147 -43.6875 38.125 C-44.69490234 37.66480469 -45.70230469 37.20460938 -46.74023438 36.73046875 C-48.20493164 36.06337891 -48.20493164 36.06337891 -49.69921875 35.3828125 C-50.59471436 34.97434082 -51.49020996 34.56586914 -52.4128418 34.14501953 C-54.92046473 33.03520057 -57.44750276 32.00168923 -60 31 C-58.72303743 28.44607486 -57.7084486 28.21553571 -55.13671875 27.03125 C-53.86090942 26.43425293 -53.86090942 26.43425293 -52.55932617 25.82519531 C-51.61162354 25.38788086 -50.6639209 24.95056641 -49.6875 24.5 C-41.90667569 20.86016108 -34.19366202 17.11621683 -26.53125 13.234375 C-25.71944778 12.82396973 -24.90764557 12.41356445 -24.07124329 11.99072266 C-20.78713533 10.32960659 -17.50357935 8.66765187 -14.22738647 6.9909668 C-11.90891649 5.80481238 -9.58580567 4.62822584 -7.26171875 3.453125 C-6.20537231 2.90709625 -6.20537231 2.90709625 -5.12768555 2.35003662 C-3.44782125 1.50555554 -1.72676101 0.74390105 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(306,423)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.084021 0.00523682 2.16804199 0.01047363 3.28491211 0.01586914 C4.45473633 0.0190918 5.62456055 0.02231445 6.82983398 0.02563477 C8.0615332 0.03401367 9.29323242 0.04239258 10.56225586 0.05102539 C12.41560547 0.05779297 12.41560547 0.05779297 14.30639648 0.06469727 C17.37089703 0.07652931 20.43530307 0.09301366 23.49975586 0.11352539 C24.24077604 4.31349443 24.60968516 8.21988799 24.56225586 12.48852539 C24.55323242 13.54813477 24.54420898 14.60774414 24.53491211 15.69946289 C24.52331055 16.49610352 24.51170898 17.29274414 24.49975586 18.11352539 C25.67151367 18.35586914 26.84327148 18.59821289 28.05053711 18.84790039 C29.63786467 19.18602934 31.22509929 19.52459474 32.81225586 19.86352539 C33.57860352 20.02079102 34.34495117 20.17805664 35.13452148 20.34008789 C41.63301709 21.74225292 47.09645639 23.78505286 53.49975586 26.11352539 C50.85975586 34.69352539 48.21975586 43.27352539 45.49975586 52.11352539 C43.51975586 51.78352539 41.53975586 51.45352539 39.49975586 51.11352539 C39.49975586 50.45352539 39.49975586 49.79352539 39.49975586 49.11352539 C35.84093819 48.39849657 32.17380594 47.74552942 28.49975586 47.11352539 C27.27256836 46.89954102 26.04538086 46.68555664 24.78100586 46.46508789 C15.91033337 45.07679159 7.48399113 44.28864343 -0.50024414 49.11352539 C-2.05868444 52.30124419 -2.66830118 54.23122595 -2.00024414 57.73852539 C2.06617643 64.17702462 9.85033159 65.77472173 16.68725586 67.98852539 C31.51073417 72.98375833 44.40880303 78.4115564 52.31225586 92.71508789 C56.42921851 101.03026903 56.7198036 110.29150185 54.43725586 119.23852539 C50.78563469 129.90194496 43.29820827 137.77066823 33.43725586 142.86352539 C29.8725888 144.59675086 26.27497726 145.90808459 22.49975586 147.11352539 C22.50499268 147.71414795 22.51022949 148.31477051 22.515625 148.93359375 C22.536336 151.63939377 22.54939711 154.34517716 22.56225586 157.05102539 C22.57063477 157.99655273 22.57901367 158.94208008 22.58764648 159.91625977 C22.59086914 160.81538086 22.5940918 161.71450195 22.59741211 162.64086914 C22.60264893 163.47352295 22.60788574 164.30617676 22.61328125 165.1640625 C22.49975586 167.11352539 22.49975586 167.11352539 21.49975586 168.11352539 C19.64605975 168.20090184 17.78908045 168.22050692 15.93334961 168.21118164 C14.80864258 168.20795898 13.68393555 168.20473633 12.52514648 168.20141602 C11.34114258 168.19303711 10.15713867 168.1846582 8.93725586 168.17602539 C7.74938477 168.17151367 6.56151367 168.16700195 5.33764648 168.16235352 C2.39166174 168.15052225 -0.5542973 168.13258615 -3.50024414 168.11352539 C-4.49024414 158.21352539 -4.49024414 158.21352539 -5.50024414 148.11352539 C-7.12961914 148.07227539 -8.75899414 148.03102539 -10.43774414 147.98852539 C-19.53337709 147.26130891 -29.87289653 144.1984238 -37.50024414 139.11352539 C-36.253881 130.15939018 -34.1331156 121.75343367 -31.50024414 113.11352539 C-28.48511573 114.11557254 -25.47229013 115.12305925 -22.46508789 116.14868164 C-20.96655273 116.6572168 -20.96655273 116.6572168 -19.43774414 117.17602539 C-17.9353418 117.68842773 -17.9353418 117.68842773 -16.40258789 118.21118164 C-10.59184415 120.01775204 -5.23582774 120.32587195 0.81225586 120.36352539 C1.62887695 120.38415039 2.44549805 120.40477539 3.28686523 120.42602539 C9.40056365 120.46499717 15.35629335 119.84920471 20.17285156 115.6574707 C22.02312405 113.50455015 22.29858319 111.92994276 22.49975586 109.11352539 C21.65673368 106.11349675 21.01778885 104.51177605 18.52319336 102.59399414 C11.33639718 99.08539601 4.04736196 96.60897881 -3.56274414 94.17602539 C-16.13024992 90.11951647 -26.44758973 85.98850761 -33.50024414 74.11352539 C-38.13666814 64.95700343 -37.54369121 54.34271411 -34.61352539 44.71899414 C-32.68535274 40.2063936 -29.77313718 36.72322622 -26.50024414 33.11352539 C-25.73711914 32.22665039 -24.97399414 31.33977539 -24.18774414 30.42602539 C-18.8154578 25.8033604 -12.77018512 21.49615386 -5.50024414 21.11352539 C-4.84024414 18.47352539 -4.18024414 15.83352539 -3.50024414 13.11352539 C-4.16024414 12.78352539 -4.82024414 12.45352539 -5.50024414 12.11352539 C-4.84024414 12.11352539 -4.18024414 12.11352539 -3.50024414 12.11352539 C-3.5118457 11.33106445 -3.52344727 10.54860352 -3.53540039 9.74243164 C-3.54442383 8.73051758 -3.55344727 7.71860352 -3.56274414 6.67602539 C-3.5743457 5.66668945 -3.58594727 4.65735352 -3.59790039 3.61743164 C-3.46630953 0.243442 -3.37173182 0.15309592 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(497.500244140625,409.886474609375)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.78801981 1.5960066 5.89358359 5.73518614 8.125 10.0625 C8.60928467 10.99771484 9.09356934 11.93292969 9.5925293 12.89648438 C20.08077523 33.67699852 27.32837635 56.36645065 31.45703125 79.26171875 C31.8644132 81.94941437 31.8644132 81.94941437 33 84 C34.1011142 94.77512694 34.18639516 105.63204916 34.18530273 116.45361328 C34.18749219 118.86638994 34.20575636 121.27870947 34.22460938 123.69140625 C34.35700523 160.16137331 26.18598099 200.74770477 5 231 C-0.75048585 226.9757473 -5.62916575 222.49187336 -10.53125 217.46875 C-13.36264289 214.63735711 -16.33279624 212.03596707 -19.40625 209.47265625 C-21 208 -21 208 -23 205 C-21.92978126 202.12587149 -20.77771495 199.49514566 -19.4375 196.75 C-4.26758412 164.03102031 0.19319251 127.54583984 -4.375 91.875 C-4.50092529 90.89128418 -4.62685059 89.90756836 -4.7565918 88.89404297 C-5.22883209 85.4155479 -5.22883209 85.4155479 -6 82 C-6.66 81.67 -7.32 81.34 -8 81 C-7.96777344 79.97390625 -7.93554688 78.9478125 -7.90234375 77.890625 C-8.29795461 62.12948831 -17.06457473 44.02394678 -24.33496094 30.25048828 C-26.27271863 26.57384287 -27.79924594 22.98016447 -29 19 C-27.91203125 18.29875 -26.8240625 17.5975 -25.703125 16.875 C-24.99687988 16.41899414 -24.29063477 15.96298828 -23.56298828 15.49316406 C-22.01521372 14.49398851 -20.46670488 13.49594951 -18.91748047 12.49902344 C-15.34727672 10.1951391 -11.79317821 7.87939641 -8.3046875 5.453125 C-6.73074219 4.36257813 -6.73074219 4.36257813 -5.125 3.25 C-4.19945312 2.59515625 -3.27390625 1.9403125 -2.3203125 1.265625 C-1.55460938 0.84796875 -0.78890625 0.4303125 0 0 Z ",
    fill: "#FEFEFE",
    transform: "translate(708,371)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2.66460576 3.12125291 3.22055851 5.27683362 3.7265625 7.44140625 C3.87910492 8.08367661 4.03164734 8.72594696 4.18881226 9.38768005 C4.67535247 11.44420521 5.150279 13.50321783 5.625 15.5625 C5.95236501 16.95525698 6.28048048 18.34783779 6.609375 19.74023438 C7.41497552 23.15815315 8.21018049 26.5783958 9 30 C12.90206729 30 15.23404606 28.28900009 18.4609375 26.31640625 C19.08851959 25.94144516 19.71610168 25.56648407 20.36270142 25.18016052 C23.04702717 23.57632975 25.72220919 21.95753142 28.39746094 20.33862305 C30.35257982 19.15853848 32.3127801 17.98725814 34.2734375 16.81640625 C34.87255951 16.44971329 35.47168152 16.08302032 36.08895874 15.70521545 C39.3471508 13.76199228 42.18013591 12.27570369 46 12 C48.17578125 13.625 48.17578125 13.625 50.3125 16 C53.11671311 18.99888576 55.88655359 21.88406606 59 24.5625 C59.639375 25.11421875 60.27875 25.6659375 60.9375 26.234375 C61.618125 26.81703125 62.29875 27.3996875 63 28 C64.67182371 29.43149905 66.33847993 30.86905444 68 32.3125 C68.763125 32.96863281 69.52625 33.62476563 70.3125 34.30078125 C72 36 72 36 72 38 C70.5925293 39.07470703 70.5925293 39.07470703 68.57421875 40.2578125 C67.80980469 40.71099854 67.04539062 41.16418457 66.2578125 41.63110352 C65.40960937 42.12408936 64.56140625 42.6170752 63.6875 43.125 C62.81480469 43.64054443 61.94210937 44.15608887 61.04296875 44.68725586 C59.10519402 45.83124943 57.16545801 46.97192517 55.22412109 48.10986328 C49.91127306 51.2245134 44.60977071 54.35829206 39.30923462 57.49383545 C37.52105613 58.55006273 35.73078715 59.6026722 33.94018555 60.65478516 C32.83586182 61.30624512 31.73153809 61.95770508 30.59375 62.62890625 C29.61083984 63.20713135 28.62792969 63.78535645 27.61523438 64.38110352 C24.7015395 66.13104183 24.7015395 66.13104183 21 69 C23.31 78.57 25.62 88.14 28 98 C16.83054533 93.53221813 7.06006761 86.10525962 -2.88330078 79.42041016 C-4.70897387 78.19529297 -6.53819233 76.97598085 -8.37109375 75.76171875 C-13.53959506 72.33664285 -18.66322135 68.85716616 -23.75 65.3125 C-28.42242544 62.06260601 -33.1369748 58.9559565 -38 56 C-36.41158959 51.05296276 -33.48741498 47.38470792 -30.375 43.3125 C-29.35767469 41.97853219 -28.34443156 40.64143804 -27.3359375 39.30078125 C-26.88782715 38.71466064 -26.4397168 38.12854004 -25.97802734 37.5246582 C-24.82002231 36.02132839 -24.82002231 36.02132839 -25 34 C-24.27425781 33.28070312 -23.54851563 32.56140625 -22.80078125 31.8203125 C-19.72772124 28.7258225 -17.52703527 25.52818807 -15.1875 21.875 C-11.47276695 16.18261916 -7.63570412 10.6384523 -3.59375 5.171875 C-2.3517758 3.47938075 -1.16447898 1.74671846 0 0 Z ",
    fill: "#FDFEFD",
    transform: "translate(582,646)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFA",
    transform: "translate(0,0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FDFDFD",
    transform: "translate(369,572)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#FCFCFB",
    transform: "translate(482,558)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFD",
    transform: "translate(0,0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#FCFDFD",
    transform: "translate(692,422)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#FDFCFC",
    transform: "translate(367,357)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#FDFDFF",
    transform: "translate(596,316)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#F6F7F7",
    transform: "translate(541,257)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EFF1F2",
    transform: "translate(0,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F0F2F2",
    transform: "translate(0,0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F7F6F8",
    transform: "translate(479,731)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F8F8F8",
    transform: "translate(418,715)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F9",
    transform: "translate(0,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F7F7",
    transform: "translate(0,0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFB",
    transform: "translate(0,0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFFFE",
    transform: "translate(619,657)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCFCFE",
    transform: "translate(698,603)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FAF9F9",
    transform: "translate(717,598)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFC",
    transform: "translate(0,0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFDFC",
    transform: "translate(361,552)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFCFB",
    transform: "translate(0,0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFC",
    transform: "translate(0,0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFB",
    transform: "translate(0,0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFD",
    transform: "translate(0,0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFEFE",
    transform: "translate(532,460)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FEFCFC",
    transform: "translate(661,451)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFD",
    transform: "translate(0,0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFD",
    transform: "translate(0,0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFD",
    transform: "translate(0,0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFDFD",
    transform: "translate(368,419)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F5F7",
    transform: "translate(0,0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F8FAF9",
    transform: "translate(306,363)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FBFCFC",
    transform: "translate(663,355)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCFDFD",
    transform: "translate(659,354)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FDFCFD",
    transform: "translate(573,350)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCFAFD",
    transform: "translate(601,348)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FEFDFE",
    transform: "translate(563,346)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F9F6F9",
    transform: "translate(344,312)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5F5F6",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FCFCFC",
    transform: "translate(458,301)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#FBFDFC",
    transform: "translate(637,290)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1F0F2",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAF9",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#F9FAF9",
    transform: "translate(476,256)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888888",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888788",
    transform: "translate(0,0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888586",
    transform: "translate(0,0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868784",
    transform: "translate(0,0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878787",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858888",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868686",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#828182",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888587",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#82817F",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858583",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868685",
    transform: "translate(0,0)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858485",
    transform: "translate(0,0)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#838483",
    transform: "translate(0,0)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848585",
    transform: "translate(0,0)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8C8A",
    transform: "translate(0,0)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868685",
    transform: "translate(0,0)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888787",
    transform: "translate(0,0)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A898B",
    transform: "translate(0,0)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878685",
    transform: "translate(0,0)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858784",
    transform: "translate(0,0)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848685",
    transform: "translate(0,0)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#818182",
    transform: "translate(0,0)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#81817F",
    transform: "translate(0,0)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#82817F",
    transform: "translate(0,0)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868787",
    transform: "translate(0,0)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858584",
    transform: "translate(0,0)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878789",
    transform: "translate(0,0)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8A8A",
    transform: "translate(0,0)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858687",
    transform: "translate(0,0)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868585",
    transform: "translate(0,0)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868686",
    transform: "translate(0,0)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868585",
    transform: "translate(0,0)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858684",
    transform: "translate(0,0)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807D7F",
    transform: "translate(0,0)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858686",
    transform: "translate(0,0)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898986",
    transform: "translate(0,0)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848584",
    transform: "translate(0,0)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878786",
    transform: "translate(0,0)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878786",
    transform: "translate(0,0)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F827E",
    transform: "translate(0,0)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848181",
    transform: "translate(0,0)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868584",
    transform: "translate(0,0)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878586",
    transform: "translate(0,0)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807E7E",
    transform: "translate(0,0)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#82807F",
    transform: "translate(0,0)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878A87",
    transform: "translate(0,0)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848584",
    transform: "translate(0,0)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888586",
    transform: "translate(0,0)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878485",
    transform: "translate(0,0)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868786",
    transform: "translate(0,0)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858587",
    transform: "translate(0,0)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8B8C",
    transform: "translate(0,0)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8989",
    transform: "translate(0,0)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848485",
    transform: "translate(0,0)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868586",
    transform: "translate(0,0)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858687",
    transform: "translate(0,0)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#838182",
    transform: "translate(0,0)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7C7C",
    transform: "translate(0,0)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888786",
    transform: "translate(0,0)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858584",
    transform: "translate(0,0)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868686",
    transform: "translate(0,0)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868687",
    transform: "translate(0,0)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898989",
    transform: "translate(0,0)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868787",
    transform: "translate(0,0)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868687",
    transform: "translate(0,0)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858686",
    transform: "translate(0,0)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878587",
    transform: "translate(0,0)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888687",
    transform: "translate(0,0)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7F7F",
    transform: "translate(0,0)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807F7F",
    transform: "translate(0,0)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8B8C",
    transform: "translate(0,0)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858584",
    transform: "translate(0,0)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878786",
    transform: "translate(0,0)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878887",
    transform: "translate(0,0)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848481",
    transform: "translate(0,0)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7E7E",
    transform: "translate(0,0)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8B8B",
    transform: "translate(0,0)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F8080",
    transform: "translate(0,0)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8A8A",
    transform: "translate(0,0)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848386",
    transform: "translate(0,0)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848484",
    transform: "translate(0,0)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868486",
    transform: "translate(0,0)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878784",
    transform: "translate(0,0)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7E7D",
    transform: "translate(0,0)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#828283",
    transform: "translate(0,0)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868785",
    transform: "translate(0,0)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898788",
    transform: "translate(0,0)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868687",
    transform: "translate(0,0)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878685",
    transform: "translate(0,0)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868685",
    transform: "translate(0,0)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878584",
    transform: "translate(0,0)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868685",
    transform: "translate(0,0)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848584",
    transform: "translate(0,0)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848583",
    transform: "translate(0,0)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7C7C",
    transform: "translate(0,0)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848585",
    transform: "translate(0,0)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858385",
    transform: "translate(0,0)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7D7E",
    transform: "translate(0,0)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848483",
    transform: "translate(0,0)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868683",
    transform: "translate(0,0)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#838584",
    transform: "translate(0,0)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F7F7F",
    transform: "translate(0,0)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7B7B",
    transform: "translate(0,0)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7E7D",
    transform: "translate(0,0)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888A88",
    transform: "translate(0,0)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7D7C",
    transform: "translate(0,0)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7F817F",
    transform: "translate(0,0)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#818080",
    transform: "translate(0,0)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868786",
    transform: "translate(0,0)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868585",
    transform: "translate(0,0)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878889",
    transform: "translate(0,0)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848586",
    transform: "translate(0,0)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7F80",
    transform: "translate(0,0)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7A7C",
    transform: "translate(0,0)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7A7B",
    transform: "translate(0,0)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898887",
    transform: "translate(0,0)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898887",
    transform: "translate(0,0)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#88888A",
    transform: "translate(0,0)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888888",
    transform: "translate(0,0)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858684",
    transform: "translate(0,0)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#828080",
    transform: "translate(0,0)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#828484",
    transform: "translate(0,0)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898989",
    transform: "translate(0,0)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868787",
    transform: "translate(0,0)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7E7C",
    transform: "translate(0,0)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#89888A",
    transform: "translate(0,0)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8A8B",
    transform: "translate(0,0)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878586",
    transform: "translate(0,0)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858483",
    transform: "translate(0,0)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A8B89",
    transform: "translate(0,0)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B898A",
    transform: "translate(0,0)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A8A8A",
    transform: "translate(0,0)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898A88",
    transform: "translate(0,0)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868987",
    transform: "translate(0,0)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7A7B",
    transform: "translate(0,0)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7E7C7D",
    transform: "translate(0,0)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A8A8B",
    transform: "translate(0,0)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A8A89",
    transform: "translate(0,0)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#828383",
    transform: "translate(0,0)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868686",
    transform: "translate(0,0)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878686",
    transform: "translate(0,0)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848484",
    transform: "translate(0,0)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8C8B",
    transform: "translate(0,0)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8A8A",
    transform: "translate(0,0)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8C8C",
    transform: "translate(0,0)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8C8C",
    transform: "translate(0,0)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7B7A",
    transform: "translate(0,0)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878989",
    transform: "translate(0,0)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8B8B",
    transform: "translate(0,0)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#79797A",
    transform: "translate(0,0)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7C7C",
    transform: "translate(0,0)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#787A79",
    transform: "translate(0,0)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#838483",
    transform: "translate(0,0)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858482",
    transform: "translate(0,0)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8E8C",
    transform: "translate(0,0)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8E8E",
    transform: "translate(0,0)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888687",
    transform: "translate(0,0)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868685",
    transform: "translate(0,0)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8D8C",
    transform: "translate(0,0)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7A7A",
    transform: "translate(0,0)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868684",
    transform: "translate(0,0)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92918F",
    transform: "translate(0,0)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898A8B",
    transform: "translate(0,0)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858483",
    transform: "translate(0,0)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D908E",
    transform: "translate(0,0)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949293",
    transform: "translate(0,0)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8A8B",
    transform: "translate(0,0)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939291",
    transform: "translate(0,0)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#807E81",
    transform: "translate(0,0)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848486",
    transform: "translate(0,0)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878887",
    transform: "translate(0,0)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8C8B",
    transform: "translate(0,0)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797A7A",
    transform: "translate(0,0)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7B7B",
    transform: "translate(0,0)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969795",
    transform: "translate(0,0)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929392",
    transform: "translate(0,0)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#79797B",
    transform: "translate(0,0)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7C7B",
    transform: "translate(0,0)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797B79",
    transform: "translate(0,0)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969998",
    transform: "translate(0,0)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#81827F",
    transform: "translate(0,0)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7B7A",
    transform: "translate(0,0)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7C7E7D",
    transform: "translate(0,0)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868988",
    transform: "translate(0,0)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848382",
    transform: "translate(0,0)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#797B7B",
    transform: "translate(0,0)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7B7B79",
    transform: "translate(0,0)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A29F9F",
    transform: "translate(0,0)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848381",
    transform: "translate(0,0)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9C",
    transform: "translate(0,0)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878B88",
    transform: "translate(0,0)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A6A4",
    transform: "translate(0,0)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7C7D",
    transform: "translate(0,0)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9C9C",
    transform: "translate(0,0)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898B8B",
    transform: "translate(0,0)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7A7D7C",
    transform: "translate(0,0)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7C7E",
    transform: "translate(0,0)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9FA0",
    transform: "translate(0,0)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A8787",
    transform: "translate(0,0)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#7D7E7E",
    transform: "translate(0,0)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B2B1",
    transform: "translate(0,0)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8D8A",
    transform: "translate(0,0)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919290",
    transform: "translate(0,0)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8C8B",
    transform: "translate(0,0)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8A8A",
    transform: "translate(0,0)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8B8C",
    transform: "translate(0,0)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929291",
    transform: "translate(0,0)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#858484",
    transform: "translate(0,0)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B6B6",
    transform: "translate(0,0)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8E8E",
    transform: "translate(0,0)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#878A87",
    transform: "translate(0,0)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#888887",
    transform: "translate(0,0)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#868787",
    transform: "translate(0,0)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8D8F8E",
    transform: "translate(0,0)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#848584",
    transform: "translate(0,0)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908E",
    transform: "translate(0,0)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908E",
    transform: "translate(0,0)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9A",
    transform: "translate(0,0)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979A99",
    transform: "translate(0,0)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BBBBBA",
    transform: "translate(0,0)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CED2D0",
    transform: "translate(0,0)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979596",
    transform: "translate(0,0)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969695",
    transform: "translate(0,0)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9EAE9",
    transform: "translate(0,0)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E9ECEA",
    transform: "translate(0,0)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#918E90",
    transform: "translate(0,0)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EDEDEE",
    transform: "translate(0,0)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EEF0EE",
    transform: "translate(0,0)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#EDECF0",
    transform: "translate(0,0)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1F0EE",
    transform: "translate(0,0)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F6F7",
    transform: "translate(0,0)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3F1F3",
    transform: "translate(0,0)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#898688",
    transform: "translate(0,0)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F9FA",
    transform: "translate(0,0)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F8F8",
    transform: "translate(0,0)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F7F6",
    transform: "translate(0,0)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2F3F3",
    transform: "translate(0,0)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3F5F6",
    transform: "translate(0,0)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1F4F3",
    transform: "translate(0,0)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F8F8",
    transform: "translate(0,0)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5F7F6",
    transform: "translate(0,0)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F5F5",
    transform: "translate(0,0)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F6F6",
    transform: "translate(0,0)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999899",
    transform: "translate(0,0)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F7",
    transform: "translate(0,0)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#908D8F",
    transform: "translate(0,0)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F5F8",
    transform: "translate(0,0)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F6F8",
    transform: "translate(0,0)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F7F8",
    transform: "translate(0,0)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929190",
    transform: "translate(0,0)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F6F7",
    transform: "translate(0,0)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A8A8A",
    transform: "translate(0,0)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8A8A",
    transform: "translate(0,0)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909392",
    transform: "translate(0,0)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F7F9",
    transform: "translate(0,0)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8A888A",
    transform: "translate(0,0)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9FB",
    transform: "translate(0,0)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F6F7",
    transform: "translate(0,0)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F8F8",
    transform: "translate(0,0)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9F9",
    transform: "translate(0,0)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F6F5",
    transform: "translate(0,0)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939293",
    transform: "translate(0,0)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9C9E",
    transform: "translate(0,0)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFB",
    transform: "translate(0,0)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9F8",
    transform: "translate(0,0)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2F6F6",
    transform: "translate(0,0)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAFB",
    transform: "translate(0,0)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B2B3",
    transform: "translate(0,0)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F8",
    transform: "translate(0,0)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7AAA8",
    transform: "translate(0,0)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8B8C8B",
    transform: "translate(0,0)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F8F8",
    transform: "translate(0,0)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F6F9",
    transform: "translate(0,0)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5F5F6",
    transform: "translate(0,0)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4F5F4",
    transform: "translate(0,0)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F6F8",
    transform: "translate(0,0)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFAF9",
    transform: "translate(0,0)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAF9",
    transform: "translate(0,0)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F7FB",
    transform: "translate(0,0)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2F4F5",
    transform: "translate(0,0)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F9F9",
    transform: "translate(0,0)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFBFF",
    transform: "translate(0,0)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F6",
    transform: "translate(0,0)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFCFA",
    transform: "translate(0,0)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3F2F2",
    transform: "translate(0,0)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F5F5",
    transform: "translate(0,0)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959394",
    transform: "translate(0,0)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F1F2F2",
    transform: "translate(0,0)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F8F9",
    transform: "translate(0,0)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9A",
    transform: "translate(0,0)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F8F8",
    transform: "translate(0,0)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFC",
    transform: "translate(0,0)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F6F9",
    transform: "translate(0,0)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFA",
    transform: "translate(0,0)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBF9F7",
    transform: "translate(0,0)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F5F8F7",
    transform: "translate(0,0)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9E9B",
    transform: "translate(0,0)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABABAB",
    transform: "translate(0,0)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F8",
    transform: "translate(0,0)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAFB",
    transform: "translate(0,0)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFD",
    transform: "translate(0,0)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F2F2F4",
    transform: "translate(0,0)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFEFE",
    transform: "translate(0,0)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F3F5F5",
    transform: "translate(0,0)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFD",
    transform: "translate(0,0)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979895",
    transform: "translate(0,0)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFB",
    transform: "translate(0,0)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFD",
    transform: "translate(0,0)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFE",
    transform: "translate(0,0)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFDFD",
    transform: "translate(0,0)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFC",
    transform: "translate(0,0)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989897",
    transform: "translate(0,0)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F8F8",
    transform: "translate(0,0)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939696",
    transform: "translate(0,0)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F8",
    transform: "translate(0,0)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A98",
    transform: "translate(0,0)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4F2F5",
    transform: "translate(0,0)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#92928F",
    transform: "translate(0,0)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFF",
    transform: "translate(0,0)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFBFD",
    transform: "translate(0,0)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFD",
    transform: "translate(0,0)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A5",
    transform: "translate(0,0)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BFC0BF",
    transform: "translate(0,0)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFD",
    transform: "translate(0,0)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A2A0",
    transform: "translate(0,0)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFF",
    transform: "translate(0,0)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFE",
    transform: "translate(0,0)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F6F7",
    transform: "translate(0,0)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F6F8",
    transform: "translate(0,0)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C9C7C8",
    transform: "translate(0,0)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFC",
    transform: "translate(0,0)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A4A4A4",
    transform: "translate(0,0)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F7",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFA",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFD",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFE",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999697",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFA",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FCF9",
    transform: "translate(0,0)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9FB",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FCF9",
    transform: "translate(0,0)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9E9D",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFB",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF9FA",
    transform: "translate(0,0)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999695",
    transform: "translate(0,0)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999798",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999999",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAFC",
    transform: "translate(0,0)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAF8",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFB",
    transform: "translate(0,0)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9999",
    transform: "translate(0,0)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F8F9",
    transform: "translate(0,0)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFA",
    transform: "translate(0,0)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9D",
    transform: "translate(0,0)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFC",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBF9FB",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFC",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7FA",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFB",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFF",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFB",
    transform: "translate(0,0)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFC",
    transform: "translate(0,0)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFE",
    transform: "translate(0,0)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFB",
    transform: "translate(0,0)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFB",
    transform: "translate(0,0)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFA",
    transform: "translate(0,0)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFBFB",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9998",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F8",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFC",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B1B0AE",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFFFE",
    transform: "translate(0,0)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFB",
    transform: "translate(0,0)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFE",
    transform: "translate(0,0)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFB",
    transform: "translate(0,0)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFC",
    transform: "translate(0,0)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFA",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFD",
    transform: "translate(0,0)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFE",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFB",
    transform: "translate(0,0)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFB",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFC",
    transform: "translate(0,0)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFD",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFC",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFC",
    transform: "translate(0,0)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFF",
    transform: "translate(0,0)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F9",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFCFD",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999899",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFE",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9FA",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4F4F5",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFC",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFB",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFD",
    transform: "translate(0,0)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFF",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFE",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFD",
    transform: "translate(0,0)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F8FA",
    transform: "translate(0,0)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#AEAEAC",
    transform: "translate(0,0)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFE",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAF8",
    transform: "translate(0,0)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFE",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9A9B",
    transform: "translate(0,0)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFCFF",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F8",
    transform: "translate(0,0)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFE",
    transform: "translate(0,0)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFEFE",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFCFF",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFD",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F7F9",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFF",
    transform: "translate(0,0)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF8F8",
    transform: "translate(0,0)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F8",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFC",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFD",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFC",
    transform: "translate(0,0)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFD",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFD",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF7FA",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFCFC",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFD",
    transform: "translate(0,0)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFC",
    transform: "translate(0,0)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFC",
    transform: "translate(0,0)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B5B7B5",
    transform: "translate(0,0)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFE",
    transform: "translate(0,0)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFE",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFBFD",
    transform: "translate(0,0)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFC",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFE",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9D9C",
    transform: "translate(0,0)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9AAA8",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9A98",
    transform: "translate(0,0)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFE",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F9F9",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFE",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9A9B",
    transform: "translate(0,0)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9FA",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFE",
    transform: "translate(0,0)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFC",
    transform: "translate(0,0)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C8C9C9",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A99",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFBFE",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFC",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7FA",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9F9D",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4F4F4",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F7",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFB",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FBFA",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFE",
    transform: "translate(0,0)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFE",
    transform: "translate(0,0)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFF",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFAFC",
    transform: "translate(0,0)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFFFE",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFD",
    transform: "translate(0,0)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F5F8",
    transform: "translate(0,0)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09F",
    transform: "translate(0,0)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFBFE",
    transform: "translate(0,0)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFE",
    transform: "translate(0,0)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFB",
    transform: "translate(0,0)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F5F8",
    transform: "translate(0,0)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFC",
    transform: "translate(0,0)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFD",
    transform: "translate(0,0)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFB",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAFA",
    transform: "translate(0,0)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFB",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFAFC",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFDFF",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFE",
    transform: "translate(0,0)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAFC",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFAFD",
    transform: "translate(0,0)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A09D9E",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#BDBEBE",
    transform: "translate(0,0)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFD",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAFA",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFBFF",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFFFE",
    transform: "translate(0,0)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFB",
    transform: "translate(0,0)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9D9E",
    transform: "translate(0,0)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFA",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFC",
    transform: "translate(0,0)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAF9",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A99",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFD",
    transform: "translate(0,0)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9B9B",
    transform: "translate(0,0)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9C9C",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFE",
    transform: "translate(0,0)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFD",
    transform: "translate(0,0)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFAFA",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C1C2C0",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBF9FA",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFEFE",
    transform: "translate(0,0)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F8",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFE",
    transform: "translate(0,0)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9F9E",
    transform: "translate(0,0)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FCFA",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFB",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFCFB",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFF",
    transform: "translate(0,0)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFE",
    transform: "translate(0,0)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFF",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFFFF",
    transform: "translate(0,0)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFCFE",
    transform: "translate(0,0)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B9B8B7",
    transform: "translate(0,0)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F8",
    transform: "translate(0,0)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFC",
    transform: "translate(0,0)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFF",
    transform: "translate(0,0)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFE",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFB",
    transform: "translate(0,0)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9C",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFA",
    transform: "translate(0,0)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999A9C",
    transform: "translate(0,0)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFE",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFD",
    transform: "translate(0,0)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFE",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F7",
    transform: "translate(0,0)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFC",
    transform: "translate(0,0)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFF",
    transform: "translate(0,0)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFDFB",
    transform: "translate(0,0)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABACAC",
    transform: "translate(0,0)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F8FB",
    transform: "translate(0,0)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A2A1A1",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F9F9",
    transform: "translate(0,0)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFE",
    transform: "translate(0,0)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFC",
    transform: "translate(0,0)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFD",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFF",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFAFA",
    transform: "translate(0,0)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9998",
    transform: "translate(0,0)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9C9B9C",
    transform: "translate(0,0)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9E9E",
    transform: "translate(0,0)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFF",
    transform: "translate(0,0)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFDFF",
    transform: "translate(0,0)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFBFC",
    transform: "translate(0,0)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9F8",
    transform: "translate(0,0)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAF9",
    transform: "translate(0,0)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFAFC",
    transform: "translate(0,0)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#E1E0E1",
    transform: "translate(0,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFA",
    transform: "translate(0,0)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFC",
    transform: "translate(0,0)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFB",
    transform: "translate(0,0)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFF",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFC",
    transform: "translate(0,0)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F8F9",
    transform: "translate(0,0)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F9",
    transform: "translate(0,0)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FCFA",
    transform: "translate(0,0)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FCFB",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFE",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFD",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFE",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFD",
    transform: "translate(0,0)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8FB",
    transform: "translate(0,0)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFCFD",
    transform: "translate(0,0)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F7F8",
    transform: "translate(0,0)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFFFC",
    transform: "translate(0,0)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFCFD",
    transform: "translate(0,0)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFF",
    transform: "translate(0,0)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFE",
    transform: "translate(0,0)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFE",
    transform: "translate(0,0)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFBFB",
    transform: "translate(0,0)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFBFD",
    transform: "translate(0,0)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFEFC",
    transform: "translate(0,0)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F9",
    transform: "translate(0,0)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969495",
    transform: "translate(0,0)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFDFC",
    transform: "translate(0,0)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F8F7",
    transform: "translate(0,0)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999899",
    transform: "translate(0,0)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9B9D99",
    transform: "translate(0,0)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#B2B1B1",
    transform: "translate(0,0)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F6F7",
    transform: "translate(0,0)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFAFC",
    transform: "translate(0,0)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFFFC",
    transform: "translate(0,0)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFDFD",
    transform: "translate(0,0)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFF",
    transform: "translate(0,0)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A8A8",
    transform: "translate(0,0)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFDFE",
    transform: "translate(0,0)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFCFC",
    transform: "translate(0,0)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBFFFF",
    transform: "translate(0,0)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFC",
    transform: "translate(0,0)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFFFD",
    transform: "translate(0,0)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7FAF7",
    transform: "translate(0,0)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF8FB",
    transform: "translate(0,0)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969696",
    transform: "translate(0,0)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979696",
    transform: "translate(0,0)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#ABABAC",
    transform: "translate(0,0)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFD",
    transform: "translate(0,0)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF9FC",
    transform: "translate(0,0)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFEFC",
    transform: "translate(0,0)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFEFF",
    transform: "translate(0,0)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFAFA",
    transform: "translate(0,0)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929392",
    transform: "translate(0,0)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F8",
    transform: "translate(0,0)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFCFF",
    transform: "translate(0,0)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFBFC",
    transform: "translate(0,0)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFBFC",
    transform: "translate(0,0)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBF7FA",
    transform: "translate(0,0)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7FAF9",
    transform: "translate(0,0)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FEFDFD",
    transform: "translate(0,0)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFEFF",
    transform: "translate(0,0)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAF7",
    transform: "translate(0,0)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F7F8",
    transform: "translate(0,0)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDFCFE",
    transform: "translate(0,0)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FAFA",
    transform: "translate(0,0)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBF7FA",
    transform: "translate(0,0)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCF9F9",
    transform: "translate(0,0)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9C9D",
    transform: "translate(0,0)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F8FA",
    transform: "translate(0,0)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F8",
    transform: "translate(0,0)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FDF9FA",
    transform: "translate(0,0)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959595",
    transform: "translate(0,0)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9F9",
    transform: "translate(0,0)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF9FB",
    transform: "translate(0,0)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F4F6F6",
    transform: "translate(0,0)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FBF8F8",
    transform: "translate(0,0)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F7F9",
    transform: "translate(0,0)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F8",
    transform: "translate(0,0)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929695",
    transform: "translate(0,0)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAFBFB",
    transform: "translate(0,0)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9FA",
    transform: "translate(0,0)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FCFAFA",
    transform: "translate(0,0)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFA",
    transform: "translate(0,0)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9F9",
    transform: "translate(0,0)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F6F6F8",
    transform: "translate(0,0)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8FBF9",
    transform: "translate(0,0)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAF9",
    transform: "translate(0,0)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FAF9F9",
    transform: "translate(0,0)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F8F9F9",
    transform: "translate(0,0)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F9FB",
    transform: "translate(0,0)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9F9F7",
    transform: "translate(0,0)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFA",
    transform: "translate(0,0)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FAFB",
    transform: "translate(0,0)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969696",
    transform: "translate(0,0)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F9FBFB",
    transform: "translate(0,0)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#F7F8F7",
    transform: "translate(0,0)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919393",
    transform: "translate(0,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#C9CAC9",
    transform: "translate(0,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909392",
    transform: "translate(0,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909191",
    transform: "translate(0,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989996",
    transform: "translate(0,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969697",
    transform: "translate(0,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929292",
    transform: "translate(0,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929293",
    transform: "translate(0,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929292",
    transform: "translate(0,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929292",
    transform: "translate(0,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908E",
    transform: "translate(0,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8C8E8F",
    transform: "translate(0,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A9A9A7",
    transform: "translate(0,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#CECDD0",
    transform: "translate(0,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F918E",
    transform: "translate(0,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919192",
    transform: "translate(0,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908F",
    transform: "translate(0,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9290",
    transform: "translate(0,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9D9D9E",
    transform: "translate(0,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959796",
    transform: "translate(0,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A3A2A2",
    transform: "translate(0,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9E9D9E",
    transform: "translate(0,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909192",
    transform: "translate(0,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9092",
    transform: "translate(0,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919091",
    transform: "translate(0,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A7A8A7",
    transform: "translate(0,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929293",
    transform: "translate(0,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F908D",
    transform: "translate(0,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#909492",
    transform: "translate(0,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919390",
    transform: "translate(0,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9191",
    transform: "translate(0,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A8A8A8",
    transform: "translate(0,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8E8F90",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949495",
    transform: "translate(0,0)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929090",
    transform: "translate(0,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#91928F",
    transform: "translate(0,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#A6A6A5",
    transform: "translate(0,0)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9F9F9F",
    transform: "translate(0,0)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939391",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919193",
    transform: "translate(0,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919193",
    transform: "translate(0,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9DA09F",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9EA09D",
    transform: "translate(0,0)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9FA1A1",
    transform: "translate(0,0)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#8F9192",
    transform: "translate(0,0)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90908F",
    transform: "translate(0,0)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919493",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919494",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919292",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#90928F",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919090",
    transform: "translate(0,0)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999798",
    transform: "translate(0,0)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#919294",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9998",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9A9A",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9597",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929291",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959594",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949293",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999B9A",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949592",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939490",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959694",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959496",
    transform: "translate(0,0)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959696",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949495",
    transform: "translate(0,0)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9998",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A97",
    transform: "translate(0,0)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969396",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979698",
    transform: "translate(0,0)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#9A9998",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#929491",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969595",
    transform: "translate(0,0)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949495",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979897",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989997",
    transform: "translate(0,0)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979795",
    transform: "translate(0,0)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949391",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959595",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#959898",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999998",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989999",
    transform: "translate(0,0)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949593",
    transform: "translate(0,0)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#99989A",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#939594",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949595",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979896",
    transform: "translate(0,0)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979696",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969698",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979797",
    transform: "translate(0,0)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989695",
    transform: "translate(0,0)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979894",
    transform: "translate(0,0)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#949596",
    transform: "translate(0,0)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969594",
    transform: "translate(0,0)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969597",
    transform: "translate(0,0)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979895",
    transform: "translate(0,0)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969897",
    transform: "translate(0,0)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969796",
    transform: "translate(0,0)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969697",
    transform: "translate(0,0)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#979796",
    transform: "translate(0,0)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999899",
    transform: "translate(0,0)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#989A99",
    transform: "translate(0,0)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#999998",
    transform: "translate(0,0)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969696",
    transform: "translate(0,0)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#969797",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyaltyTrackingSelected);
export default __webpack_public_path__ + "static/media/royalty_tracking_selected.c2e3cf3e94960bfac340d923032b770a.svg";
export { ForwardRef as ReactComponent };